(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bb-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-size-guide')) {
    customElements.define(
      'bb-size-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.trigger = this.querySelector('[data-open]');
          if (!this.dialog || !this.trigger) return;
          this.trigger.addEventListener('click', () => this.open());
          this.dialog.querySelectorAll('[data-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => {
            document.documentElement.style.removeProperty('overflow');
            this.trigger.focus();
          });
        }

        open() {
          if (typeof this.dialog.showModal !== 'function') return;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
